import type { MessageKey } from 'types/LocaleMessageKey';

import { CURRENT_SITEWIDE_DISCOUNT } from '@/app/[locale]/product/_consts/discounts';

import { _getDiscountAppliedMessage } from './_getDiscountAppliedMessage';
import { _getInvalidOrExpiredDiscountError } from './_getInvalidOrExpiredDiscountError';
import { _getNoDiscount } from './_getNoDiscount';
import { _getNonSiteWideMessage } from './_getNonSiteWideMessage';
import type { DiscountError, GetDiscountMessage } from './types';

const getDiscountMessage = ({
  discountData,
  discountIsLoading,
  discountIsSuccess,
  promotionData,
}: GetDiscountMessage): MessageKey | null => {
  if (!discountData) return null;
  const { appliedDiscountCode, campaign, discount, promotionCodes } =
    discountData;

  const hasSitewideDiscount = promotionCodes.includes(
    CURRENT_SITEWIDE_DISCOUNT,
  );

  const invalidReason = promotionData?.invalidReason ?? null;

  let discountError: DiscountError = {
    errorMessage: null,
    errorType: null,
    invalidReason,
  };

  const hasDiscountResolved =
    (appliedDiscountCode || campaign) &&
    !discountIsLoading &&
    discountIsSuccess;

  if (hasDiscountResolved) {
    discountError = _getNoDiscount({
      discount,
      invalidReason,
      usageCount: discount?.usageCount ?? 0,
      usageLimit: discount?.usageLimit ?? 0,
      valid: discount?.valid,
    });
  }

  const { errorMessage, errorType, invalidReason: reason } = discountError;

  if (errorType) {
    // eslint-disable-next-line no-console
    console.error('Discount error:', errorType);
  }

  const message = _getNonSiteWideMessage({
    errorCode: promotionData?.errorCode,
    errorMessage,
    hasSitewideDiscount,
    reason,
  });
  if (message) return message;

  return _getDiscountAppliedMessage(discountData, discountError);
};

export default getDiscountMessage;
